"use client";

import { PageContent } from "@/app/parts/global/Page";
import clsx from "clsx";
import React from "react";
import { Typography } from "../Typography";
import { IlluminationMode } from "./Definitions";
import css from "./illuminated-image.module.scss";

interface IlluminationHandleProps
{
    activeMode: IlluminationMode;
    className?: string;
    modes: IlluminationMode[];
    onModeChange: (mode: IlluminationMode) => void;
}

export const IlluminationHandle = ({ activeMode, className, modes, onModeChange }: IlluminationHandleProps): React.FunctionComponentElement<IlluminationHandleProps> =>
{
    const classes = clsx(css["handle"], className);
    return (
        <table className={classes} cellPadding={0} cellSpacing={0}>
            <tbody>
                {
                    modes.map((mode, modeKey) =>
                        <tr key={modeKey} data-active={mode === activeMode} onClick={() => onModeChange(mode)}>
                            <td>
                                <PageContent {...mode.title} typography={Typography.P3} />
                            </td>
                            <td>
                                <PageContent {...mode.description} typography={Typography.P3} />
                            </td>
                        </tr>
                    )
                }
            </tbody>
        </table>
    )
}